module.exports = __webpack_public_path__ + "img/mappa-totem-2-small.c67be28a.jpg";